import React, { useCallback, useState } from 'react';
import { isMultiImageDeviation } from '../../DeviationViews/_helpers';
import { ImageSource } from '../../DeviationViews/Full/types';
import { useZoomBiLogger } from '../../DeviationViews/Full/hooks/useZoomBiLogger';
import { DefaultArtStageProps as Props } from '../types';
import DesktopMultiArtStage from './DesktopMultiArtStage';
import DesktopSingleArtStage from './DesktopSingleArtStage';

export const DesktopArtStage: React.FC<Props> = props => {
  const hasAdditionalMedia = props.deviation.extended?.additionalMedia?.length;
  const shouldRenderMultiImage =
    isMultiImageDeviation(props.deviation) && hasAdditionalMedia;

  const [zoomedImageSource, setZoomedImageSource] = useState<
    ImageSource | undefined
  >();

  const logZoomBi = useZoomBiLogger(props.deviation);

  const onEnterZoomMode = useCallback(
    source => {
      setZoomedImageSource(source);
      logZoomBi(true);
    },
    [logZoomBi]
  );

  const onExitZoomMode = useCallback(() => {
    setZoomedImageSource(undefined);
    logZoomBi(false);
  }, [logZoomBi]);

  const isZoomed = !!zoomedImageSource;

  return shouldRenderMultiImage ? (
    <DesktopMultiArtStage
      {...props}
      isZoomed={isZoomed}
      zoomedImageSource={zoomedImageSource}
      onEnterZoomMode={onEnterZoomMode}
      onExitZoomMode={onExitZoomMode}
    />
  ) : (
    <DesktopSingleArtStage
      {...props}
      isZoomed={isZoomed}
      zoomedImageSource={zoomedImageSource}
      onEnterZoomMode={onEnterZoomMode}
      onExitZoomMode={onExitZoomMode}
    />
  );
};
DesktopArtStage.displayName = 'DesktopArtStage';
export default DesktopArtStage;
